import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CustomEase } from "gsap/CustomEase";
import { media } from "../utils/MediaQueries";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CustomEase);


function secondaryHomeAnimation() {

  const secondaryBanner = $('.banner--home.secondary-animation');
  if (!secondaryBanner) return;


    let imgOneX = -65;
    let imgOneY = -67;
    let imgTwoX = 98;
    let imgTwoY = 63;
    
    if (window.matchMedia('(max-width: 1200px)').matches){
      imgOneX = -52;
      imgOneY = -45;
      imgTwoX = 68;
      //imgTwoY = 63;
    }
    if (window.matchMedia('(max-width: 992px)').matches){
      imgOneX = -5;
      imgOneY = -52;
      imgTwoX = 68;
      //imgTwoY = 93;
    }
    if (window.matchMedia('(max-width: 850px)').matches){
      imgOneX = -13;
      imgOneY = -52;
      imgTwoX = 140;
      imgTwoY = 93;
    }
    if (window.matchMedia('(max-width: 500px)').matches){
      imgOneX = 0;
    }
    if (window.matchMedia('(max-width: 370px)').matches){
      imgOneX = 9;
    }

    const homeAnimationSecondary = gsap.timeline({
      paused: false,
    });
    
    homeAnimationSecondary.delay(1);

    homeAnimationSecondary.fromTo(
      ".banner__content.js-fade-out",
      {
        opacity: 1,
        autoAlpha: 1,
      },
      {
        opacity: 0,
        autoAlpha: 0,
        duration: 0.9,
        ease: "power2.inOut",
      }
    );
    homeAnimationSecondary.fromTo(
      ".banner__content.js-fade-in",
      {
        opacity: 0,
        autoAlpha: 0,
      },
      {
        opacity: 1,
        autoAlpha: 1,
        duration: 0.9,
        ease: "power2.inOut",
      },
      ">-0.4"
    );
    homeAnimationSecondary.fromTo(
      ".banner--home .floating-images .floating-img--1",
      {
        scale: 2,
        rotate: 3,
        xPercent: 0,
        yPercent: -50,
        autoAlpha: 0,
      },
      {
        scale: 1,
        rotate: -12,
        autoAlpha: 1,
        xPercent: imgOneX,
        yPercent: imgOneY,
        duration: 1.2,
        ease: "power2.inOut",
      },
      ">-0.2"
    );
    homeAnimationSecondary.fromTo(
      ".banner--home .floating-images .floating-img--2",
      {
        scale: 2,
        rotate: 0,
        xPercent: -50,
        yPercent: 60,
        autoAlpha: 0,
      },
      {
        scale: 1,
        rotate: 18,
        autoAlpha: 1,
        xPercent: imgTwoX,
        yPercent: imgTwoY,
        duration: 1.2,
        ease: "power2.inOut",
      },
      ">-0.2"
    );
}

function homeAnimationSecondary() {
  secondaryHomeAnimation();
}

export default homeAnimationSecondary;
